import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { environment } from '@environments/environment';
import { AuthSsoService } from '@core/services/auth/auth-sso.service';

import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { SharedService } from '@shared/services/shared.service';

@Component({
  imports: [TranslatePipe, TranslateModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  selector: 'app-stencil-navbar',
  templateUrl: './stencil-navbar.component.html',
  styleUrls: ['./stencil-navbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StencilNavbarComponent {
  private authSsoService = inject(AuthSsoService);
  languageCode = inject(SharedService).languageCode;

  environmentName: string = environment.name;
  scopeEnvironmentName: string = this.getScopeEnvironmentName(environment.name);
  isLoggedIn = this.authSsoService.isLoggedIn;

  private getScopeEnvironmentName(environmentName: string): string {
    if (environmentName === 'feature') return 'dev';
    if (environmentName === 'feature-prod') return 'prod';
    return environmentName;
  }
}
